function goToTop(){
  document.getElementById("go-to-top").addEventListener('click', (e) => {
    e.preventDefault();
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  });
}

function openReferences(){
  document.getElementById("open-references").addEventListener('click', (e) => {
    document.getElementById("open-references").classList.toggle('expanded');
    document.getElementById("references-holder").classList.toggle('opened');
  });
}

function menu(){
  let topmenuUlSelector = '#block-mein-kalium-main-menu ul.parent-menu';
  let liHasChildren = document.querySelectorAll(
    // topmenuUlSelector + ' > li.has-children > a,' +
    topmenuUlSelector + ' > li.has-children:not(.opened-menu) > i'
  );
  liHasChildren.forEach(function(liChild) {
    liChild.addEventListener('click', (e) => {
      e.preventDefault();
      if(liChild.parentElement.classList.contains('opened-menu')){
        document.querySelector('.opened-menu').classList.remove('opened-menu');
      }else{
        if(document.querySelector('.opened-menu')){
          document.querySelector('.opened-menu').classList.remove('opened-menu');
        }
        liChild.parentElement.classList.add('opened-menu');
      }
    });
  });

  let openedMenuIcons = document.querySelectorAll(topmenuUlSelector + ' > li.has-children.opened-menu > i');
  openedMenuIcons.forEach(function (iconChild){
    iconChild.parentElement.classList.remove('opened-menu');
  });

  let closeButtons = document.querySelectorAll(".close-menu");
  closeButtons.forEach(function (closeButton){
    closeButton.addEventListener('click', (e) => {
      document.querySelector(".opened-menu").classList.remove('opened-menu');
    });
  });

  document.querySelector(".open-menu").addEventListener('click', (e) => {
    document.querySelector(".parent-menu").classList.toggle('expanded-menu');
  });
}

function searchBar(){
  document.querySelector("#init-search").addEventListener('click', (e) => {
    document.querySelector('#main-menu-holder #block-searchform').classList.toggle('d-none');
    document.querySelector('#main-menu-holder .region-header').classList.toggle('d-none');
    document.querySelector('#main-menu-holder #block-searchform input.form-search').focus();
  });

  document.querySelector('#close-search').addEventListener('click', (e) => {
    document.querySelector('#main-menu-holder #block-searchform').classList.toggle('d-none');
    document.querySelector('#main-menu-holder .region-header').classList.toggle('d-none');
  });
}
